<template>
  <div class="loading-wrapper">
    <div
      :style="{
        height: size + 'px',
        marginBottom: margin + 'px',
        marginTop: margin + 'px',
        width: size + 'px'
      }"
      aria-live="assertive"
      aria-label="Vänta, informationen laddas..."
      class="loading-indicator">
    </div>
  </div>
</template>

<script>
export default {
  name: 'af-spinner',

  props: {
    size: {
      default: 78,
      type: Number
    },
    margin: {
      default: 60,
      type: Number
    }
  }
}
</script>

<style lang="postcss" scoped>
.loading-indicator {
  animation: load8 1.1s infinite linear;
  border-bottom: 1.1em solid #06769f33;
  border-left: 1.1em solid #06769f;
  border-right: 1.1em solid #06769f33;
  border-top: 1.1em solid #06769f33;
  font-size: 10px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
}

.loading-indicator,
.loading-indicator:after {
  border-radius: 50%;
  height: inherit;
  width: inherit;
}

@keyframes load8 {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AfSpinner.vue